import * as React from "react";
export default class ScrollLoad extends React.Component {
    constructor() {
        super(...arguments);
        this.onScroll = () => {
            var _a;
            const { onLoadMore } = this.props;
            const scrollWrapperRef = (_a = this.props.targetRef) === null || _a === void 0 ? void 0 : _a.current;
            const contentOffsetBottom = scrollWrapperRef.getBoundingClientRect().bottom;
            if (onLoadMore && contentOffsetBottom < window.innerHeight + 200) {
                onLoadMore();
            }
        };
    }
    componentDidMount() {
        window.removeEventListener("scroll", this.onScroll);
        window.addEventListener("scroll", this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    render() {
        return this.props.children;
    }
}
